'use client';

import { Icon, IconProps } from '@phosphor-icons/react';
import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export class SvgUtil {
  static svgParaString = (Component: Icon, props?: IconProps) => {
    return `data:image/svg+xml,${encodeURIComponent(
      renderToStaticMarkup(createElement(Component, props)),
    )}`;
  };
}
